import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { Link } from "react-router-dom";
const BdDetailPage = () => {

  return (
    <Fragment>
      <main className="page_content about-page ">
        <PageTitle pageTitle={"Business Development Executive"} />
        <div className="pt-175 pb-80 ">
            <div className="container">
                <h4 className="mb-4">Job Description</h4>
                <p>We are looking for enthusiastic and career-driven Business Development Executives — fresh graduates and professionals with up to 2 years of experience — to join our dynamic sales team. The primary focus will be generating leads and closing deals via platforms like Upwork and LinkedIn. Ideal candidates will be technically inclined and passionate about building a career in the IT sales domain.</p>
                
                <h4 className="mb-4">Key Responsibilities:</h4>
                <ul>
                    <li>Search and filter relevant projects on Upwork and LinkedIn.</li>
                    <li>Draft and submit personalized, impactful proposals tailored to client needs.</li>
                    <li>Initiate and maintain professional communication with prospective clients.</li>
                    <li>Understand client requirements and collaborate with the technical team for estimations and clarifications.</li>
                    <li>Help evolve business development strategies to enhance our online presence and conversion rate.</li>
                    <li>Explore additional freelancing or B2B platforms as business expands.</li>
                </ul>

                <h4 className="mb-4">Requirements:</h4>
                <ul>
                    <li>Bachelor’s degree in Computer Science, IT, or any related field.</li>
                    <li>0–2 years of relevant experience in Upwork bidding, client hunting, or pre-sales activities.</li>
                    <li>Strong grasp of software development basics and understanding of the SDLC.</li>
                    <li>Excellent written and verbal communication skills.</li>
                    <li>Ability to write effective, concise, and client-centric proposals.</li>
                    <li>Knowledge of emerging technologies like AI, Blockchain, or Web3 is a strong plus.</li>
                    </ul>

                <p className="mt-5">Send your updated CV and a short introduction to: <strong>hr@apeitsolutions.com</strong></p>
                {/* <Link to='/seo-detail' class="btn btn-primary mt-5">
                <span class="btn_label" data-text="Apply Now"> Apply Now </span>
                <span class="btn_icon">
                    <i class="fa-solid fa-arrow-up-right"></i>
                </span>
            </Link> */}
            </div>
        </div>
      </main>
      <Scrollbar />
    </Fragment>
  );
};

export default BdDetailPage;
